import { gql, useQuery, ApolloError } from '@apollo/client'

import { useAppState } from '@hooks/app/app-state.hook'

import { SequenceLibraryFragment, SequenceTemplateFragment } from '@libs/apollo/fragments'

import { Project, QuerySequenceTemplatesArgs, SequenceLibrary, SequenceTemplate } from '@types'

export const SEQUENCE_LIST = gql`
  query sequenceList($input: SequenceTemplatesFindInput!, $organizationId: ID!) {
    sequenceTemplates(input: $input) {
      ...SequenceTemplateFragment
    }
    sequenceLibraries {
      ...SequenceLibraryFragment
    }
    projects(input: { organizationId: $organizationId }) {
      id
      name
      sequenceTemplates {
        ...SequenceTemplateFragment
      }
    }
  }
  ${SequenceTemplateFragment}
  ${SequenceLibraryFragment}
`

interface Data {
  sequenceTemplates?: SequenceTemplate[]
  sequenceLibraries?: SequenceLibrary[]
  projects?: Project[]
}

export const useSequenceList = (
  projectId: string,
): {
  loading: boolean
  error: ApolloError | undefined
  refetch: (projectId: string) => void
  data?: Data
} => {
  const { getOrganization } = useAppState()
  const organization = getOrganization()

  const { loading, error, data, refetch } = useQuery<Data, QuerySequenceTemplatesArgs & { organizationId: string }>(
    SEQUENCE_LIST,
    {
      variables: {
        input: {
          projectId,
        },
        organizationId: organization.id,
      },
      notifyOnNetworkStatusChange: true,
    },
  )

  const refetchData = (projectId: string) => {
    const variables: QuerySequenceTemplatesArgs = {
      input: {
        projectId,
      },
    }
    refetch(variables)
  }

  return { loading, error, data, refetch: refetchData }
}
